import React from 'react'
import { Button, Text } from '@sendoutcards/quantum-design-ui'
import { FlexColumn, FlexRow } from 'src/styled'
import { useAccount, useActions, useSelector } from 'src/hooks'

const FreeCardNotification = (props: {
  onComplete: () => void
  dismissModal: () => void
}) => {
  const { onComplete, dismissModal } = props
  const { isMobile } = useSelector(s => s.window)
  const account = useAccount()
  const actions = useActions()

  const onNow = account.verifiedPhoneNumber
    ? () => {
        actions.openCatalog()
        dismissModal()
      }
    : () => actions.openPhoneNumberVerification()

  const onLater = () => {
    onComplete()
  }

  return (
    <FlexColumn
      style={{
        justifyContent: 'center',
        marginBottom: isMobile ? '65px' : undefined,
      }}
    >
      <Text type="largeBody">Send your first card for free!</Text>
      <Text type="body">Do you want to send your free card now or later?</Text>
      <FlexRow
        style={{
          justifyContent: 'space-between',
          marginTop: '12px',
          marginBottom: '12px',
        }}
      >
        <div style={{ width: '20%' }}>
          <Button
            type="secondary"
            title="Later"
            onClick={onLater}
            fullWidth={true}
          />
        </div>
        <div style={{ width: '30%' }}>
          <Button type="primary" title="Now" onClick={onNow} fullWidth={true} />
        </div>
      </FlexRow>
      <Text type="body">
        You can share this link with anyone - if it’s their first card, it will
        be free!
      </Text>
      <Text type="body">
        {account.isAffiliate
          ? `https://www.sendoutcards.com/u/${account.genealogyId}/send`
          : `https://www.sendoutcards.com/u/${account.sponsor?.storefront?.slug}/send`}
      </Text>
    </FlexColumn>
  )
}

export default FreeCardNotification
